import { ReadDefensoriaDto } from '@/api.types';
import { normalizeOptionalReference } from '@/shared/utils/formZod.schema.utils';

function str(value: unknown): string {
  return value == null ? '' : String(value);
}

function bool(value: unknown): boolean | undefined {
  if (value === null || value === undefined) return undefined;
  return value === true || value === 'true';
}

/** Normaliza resposta da API para o formulário (Zod não aceita `null` em string/boolean). */
export function normalizeDefensoriaFormFromApi(
  data: ReadDefensoriaDto,
): ReadDefensoriaDto {
  return {
    ...data,
    codigo: str(data.codigo),
    anotacao: str(data.anotacao),
    exibirrelatorio: bool(data.exibirrelatorio) ?? false,
    relatoriosAtividadesHabilitado: bool(data.relatoriosAtividadesHabilitado) ?? false,
    criminal: bool(data.criminal) ?? false,
    civel: bool(data.civel) ?? false,
    ordem: data.ordem ?? 0,
    maximo_estagiarios: data.maximo_estagiarios ?? 0,
    telefone: data.telefone
      ? {
          ...data.telefone,
          numero: str(data.telefone.numero),
        }
      : data.telefone,
    defensoriasubstituta1: normalizeOptionalReference(data.defensoriasubstituta1) as
      | ReadDefensoriaDto
      | undefined,
    defensoriasubstituta2: normalizeOptionalReference(data.defensoriasubstituta2) as
      | ReadDefensoriaDto
      | undefined,
    diretoria: normalizeOptionalReference(data.diretoria),
  };
}
